<template>
  <div class="square-image" @click="openImageInNewTab">
    <img
      v-if="!imageLoadError && imageUrl"
      :src="imageUrl"
      :alt="imageLabel + '' || 'Image'"
      class="square-img"
      @error="handleImageError"
    />
    <div v-else-if="imageLoadError" class="image-placeholder">
      <p>Failed to load image</p>
    </div>
    <div v-else-if="!imageUrl" class="image-placeholder">
      <p>No image available</p>
    </div>
    <div class="key-overlay" v-if="imageLabel">
      {{ imageLabel }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageComponent',
  props: ['imageLabel', 'imageUrl'],
  data() {
    return {
      imageLoadError: false,
    };
  },
  methods: {
    handleImageError() {
      this.imageLoadError = true;
    },
    openImageInNewTab() {
      if (!this.imageLoadError) {
        window.open(this.imageUrl, '_blank');
      }
    },
  },
};
</script>

<style scoped>
.square-image {
  position: relative;
  width: 200px;
  height: 200px;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
}

.square-image:hover {
  transform: scale(1.02);
}

.square-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.key-overlay {
  position: absolute;
  top: 8px;
  left: 8px;
  background-color: #12a3eb;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  background-color: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  font-size: 14px;
  text-align: center;
  border: 2px dashed #dee2e6;
}
</style>
